module.exports = __webpack_public_path__ + "img/item8.5d5b9997.png";